import { PatientOrdersEndpoint } from '../../constants/api.config'
import getCharts from '../getCharts'

export default async function PatientOrdersCRUD(mode, ordId = '-1', patientID = '-1', ordDate = '-1', data = '-1', imaging = '-1', labs = '-1') {
  try {
    const payload = { mode, ordId, patientID, ordDate, data, imaging, labs }
    const res = await getCharts(PatientOrdersEndpoint, payload)
    return res.data
  } catch (error) {
    return error
  }
}
